import { Theme } from '@/components/Block'
import GsuLoader from '@/components/GsuLoader'
import { UnitSize } from '@/constants/measured-scope'
import { SectionNavigationAction } from '@/shared/api-generated-types'
import CardRow from '@/widgets/CardRow'
import CardViewClass from '@/widgets/CardViewClass'
import { Props as ClassCardProps } from '@/widgets/ClassCard'

type CarouselOptions = false | UnitSize[] | 'always'

export interface ClassCardRowProps {
  title?: string | null
  subtitle?: string | null
  theme?: Theme
  carousel?: CarouselOptions
  items: Partial<ClassCardProps>[]
  spacing?: UnitSize
  // Callback to parent with page to load if applicable
  className?: string
  navigationActions?: SectionNavigationAction[]
  fetching?: boolean
}
export type DeviceSizes = {
  [key in UnitSize]: boolean | undefined
}

const ClassCardRow = ({
  title,
  subtitle,
  spacing = 'sm',
  theme = 'white',
  navigationActions,
  items,
  className = '',
  fetching,
}: ClassCardRowProps): JSX.Element => {
  if (fetching) return <GsuLoader consumeSpace />

  const classCards = items
    ? items.map((item) => {
        // All card event tracking should occur here in the future to avoid props drilling.
        // Search for GUID to find all implementations: 70e7b1d8-0cb9-4883-8927-1a69372cfac2
        return <CardViewClass {...(item as ClassCardProps)} key={`class_${item.id}`} />
      })
    : []

  return (
    <CardRow
      title={title}
      subtitle={subtitle}
      spacing={spacing}
      theme={theme}
      navigationActions={navigationActions}
      className={className}
    >
      {classCards}
    </CardRow>
  )
}

export default ClassCardRow
